// 身份类型
const IdentityType = {
    MedWorker: 3, // 医务工作者
    MedEntRelated: 5, // 医疗企业相关人士
    MedStudent: 8, // 医学生
    Other: 4 // 其他
}

// 其他身份类型
const OtherType = {
    Patient: 1, // 患者/患者家属
    PWO: 6, // 公益组织
    Media: 7 // 媒体
}

// 医院等级
const HospitalLevel = [
    '三级甲等',
    '三级乙等',
    '三级丙等',
    '二级甲等',
    '二级乙等',
    '二级丙等',
    '一级甲等',
    '一级乙等',
    '一级丙等',
    '诊所'
]
export {
    IdentityType,
    OtherType,
    HospitalLevel
}


// WEBPACK FOOTER //
// ./src/util/dict.js